import { defaultLanguage } from '../constants';

export class MultiLanguageText {
  constructor(item = {}) {
    this.text = item || { defaultLanguage: '' };
    if (this.text[defaultLanguage]) {
      this.text = {
        ...this.text,
        ...{ defaultLanguage: '' }
      };
    }
  }

  getText(language) {
    return this.text[language] || this.text[defaultLanguage];
  }

  getTextOrEmpty(language) {
    return this.text[language] || '';
  }
}
